import { Box, Card, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import {
    callAPI,
    clearRequest,
    Method
} from "../../commonFunctions/CommonFunctions";
import WSTextField, {
    CurrencyType,
    TextType
} from "../../Components/TextBox/WSTextBox";
import WSButton from "../../Components/Button/WSButton";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTimePicker from "../../Components/WSTimePicker/WSTimePicker";
import { HeaderList, IHeaderListActions } from "../../Components/Header/HeaderList";
import { WSIcons } from "../../commonFunctions/iIcons";

export const AddOnService: React.FC<any> = React.memo((props) => {
    const { control, register, handleSubmit, setValue } = useForm();
    const navigate = useNavigate();

    const params = useParams();
    const id = params?.id;
    const { showMessage } = useSnackbar();
    const [loading, setLoading] = useState(true); // Loading state

    useEffect(() => {
        /**
         * Edit Function
         * @param id
         *
         */
        async function getServiceById(id: any) {
            try {
                const response: any = await callAPI(
                    "service-addons",
                    Method.GET,
                    null,
                    id
                );
                

                if (response && response?.data) {
                    setValue("addOnName", response.data.addOnName);
                    setValue("price", response.data.price);

                }
            } catch (error) {
                console.error("failed to retrieve data", error);
                showMessage("Something went wrong. Please try again.", "error");
            } finally {
                setLoading(false);
            }
        }
        if (id) {
            
            getServiceById(id);
        }
    }, [id, setValue]);

    const source = {
        url: "franchises/search",
        filter: [],
        sort: [],
        page: 1,
        pageSize: 100000
    }

    const handleCancelClick = () => {
        navigate("/add-on-service/list");
    };

    const handleTransform = (data: any) => {
        let allData: Array<any> = [];

        data.map((value: any) => {
            allData.push({ label: value.name, value: value.id });
        });

        return allData;
    };

    /**
     * Method for Add/Update the data
     * @param data
     */

    const handleData = async (data: any) => {
        try {
            let request = {
                addOnName: data.addOnName,
                price: data.price,

            };

            

            const newRequest = clearRequest(request);

            if (id) {
                const response: any = await callAPI(
                    `service-addons/${id}`,
                    Method.PUT,
                    newRequest
                );
                if (response) {
                    showMessage(
                        response?.message,
                        response.success === true ? "success" : "error"
                    );
                    response.success === true && navigate("/add-on-service/list");
                }
            } else {
                const response: any = await callAPI(
                    "service-addons",
                    Method.POST,
                    newRequest
                );
                if (response) {
                    showMessage(
                        response?.message,
                        response.success === true ? "success" : "error"
                    );
                    response.success === true && navigate("/add-on-service/list");
                }
            }
        } catch (e: any) {
            showMessage(e.error);
        }
    };
     const actions: IHeaderListActions[] = [
        {
          type: "icon",
          text: "Cancel",
          size: "small",
          onClick: handleCancelClick,
          variant: "outlined",
          color: "error",
          icon:<WSIcons.CancelIcon />,
        },
        {
          type: "icon",
          text: "Save",
          size: "small",
          buttonType: "submit",
          variant: "outlined",
          color: "success",
          icon:< WSIcons.SaveIcon/>,
        }
      ];
    return (<>


        <form onSubmit={handleSubmit(handleData)}>
            <HeaderList title="Add On Service" type="card" actions={actions} />
            <Card sx={{ padding: 2, borderRadius: 2 }}>
                {/* <Grid  sx={{ border: '1px solid red', padding: 1, borderRadius: 2 }}> */}

                <Grid item container spacing={1} justifyContent={'start'} sx={{ marginTop: 0, marginLeft: 0, width: '100%', backgroundColor: "#7D79C2", borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <Grid alignContent={'center'} style={{ paddingLeft: 20, paddingTop: 0, height: '3rem' }} item sm={4} className='ws-data-grid-lightviolet-title' >
                        <Typography variant="h6" id="tableTitle" sx={{ fontSize: '1rem' }} >
                            Service Information
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    sx={{
                        padding: 3,
                        backgroundColor: "#fff",
                        borderBottomLeftRadius: 5, borderBottomRightRadius: 5,
                        border: "1px solid lightgrey",
                        // marginTop: 3,
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <WSTextField
                                label={"Add On Name"}
                                {...register("addOnName", {
                                    required: "Service Name is required"
                                })}
                                id="addOnName"
                                name="addOnName"
                                control={control}
                            //labelType="Normal"
                            />
                        </Grid>



                        <Grid item xs={12} sm={6}>
                            <WSTextField
                                label={"Price"}
                                {...register("price", {
                                    required: "Price is required"
                                })}
                                id="price"
                                name="price"
                                control={control}
                                //  labelType="Normal"
                                type={TextType.Currency}
                                currency={CurrencyType.Rupee}
                            />
                        </Grid>


                    </Grid>
                </Grid>
            </Card>
        </form>


    </>);
});
